import React, { Fragment, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Card } from "@mui/material";

import moment from "moment";

export default function EventMainPreview({ event, onClick }) {
  const [openedPopover, setOpenedPopover] = useState(false);
  const course = useSelector((state) =>
    state.courses.find((c) => c.id === event.courseId)
  );
  const getBorderColor = () => {
    if (!event.type) {
      return event.isTest ? "#ffda21" : "#195ac2";
    }
    switch (event.type) {
      case "EVENT":
        return "#457b3b";
      case "ASSIGNMENT":
        return "#3873cb";
      case "EXAM":
        return "red";
      case "QUIZ":
        return "#9031aa";
    }
  };

  const clicked = () => {
    goToZoom();
    onClick(event);
  };
  const goToZoom = () => {
    if (!event.zoom || event.zoom.length == 0) return;
    window.open(event.zoom);
  };
  return (
    <div style={{ width: "90%", marginLeft: "auto", marginRight: "auto" }}>
      <Card
        style={{
          display: "flex",
          margin: "5px",
          height: "60px",
          ...(course
            ? { backgroundColor: course.color }
            : event.isEvent
            ? { backgroundColor: "#d8d8d8" }
            : {}),
        }}
      >
        <div
          style={{
            textAlign: "center",
            width: "100%",
            paddingTop: "5px",
            cursor: !event.zoom || event.zoom.length == 0 ? "" : "pointer",
            borderRight: event.isEvent
              ? `15px solid ${getBorderColor()}`
              : "none",
            borderLeft: event.isEvent ? "15px solid #fff0" : "none",
          }}
          onClick={() => clicked()}
        >
          <div>{event.name}</div>
          {event.location.length > 0 && (
            <div style={{ fontSize: "12px", color: "#333" }}>
              {event.location}
            </div>
          )}
          <div style={{ fontSize: "11px", fontStyle: "italic", color: "#555" }}>
            {`${moment(event.startTime).format("h:mm a")} -
          ${moment(event.endTime).format("h:mm a")}`}
          </div>
        </div>
      </Card>
    </div>
  );
}
